import React, { useEffect, useState } from "react";
import UserSidebar from "./UserSidebar";

const UserPayments = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem("jwt_token");
        const userId = localStorage.getItem("user_id");

        if (!token || !userId) {
          setError("Utente non autenticato.");
          setLoading(false);
          return;
        }

        const host = import.meta.env.VITE_HOST;
        const port = import.meta.env.VITE_PORT;
        const url = `${host}:${port}/api/v1/users/get_user_orders?_id=${userId}`;

        const res = await fetch(url, {
          method: "GET",
          headers: { Authorization: `Bearer ${token}` },
        });

        const data = await res.json();

        if (!res.ok) {
          throw new Error(data?.detail || "Errore durante il recupero dei pagamenti.");
        }

        const sorted = (data.data || []).sort(
          (a, b) => new Date(b.order_date) - new Date(a.order_date)
        );
        setOrders(sorted);
      } catch (err) {
        setError(err.message || "Errore sconosciuto");
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  return (
    <div className="flex bg-gray-100 min-h-screen">
      <UserSidebar />

      <div className="flex-1 p-6 md:p-10">
        <h1 className="text-2xl font-bold text-[#94c41c] mb-6">Storico Transazioni</h1>

        {loading ? (
          <p className="text-gray-700">Caricamento...</p>
        ) : error ? (
          <p className="text-red-600">{error}</p>
        ) : orders.length === 0 ? (
          <p className="text-gray-700">Nessun pagamento trovato.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="min-w-full bg-white rounded-xl shadow border border-gray-200">
              <thead className="bg-gray-100">
                <tr>
                  <th className="text-left px-4 py-3 font-semibold text-gray-700">Dominio</th>
                  <th className="text-left px-4 py-3 font-semibold text-gray-700">Metodo</th>
                  <th className="text-left px-4 py-3 font-semibold text-gray-700">Importo (€)</th>
                  <th className="text-left px-4 py-3 font-semibold text-gray-700">Data</th>
                  <th className="text-left px-4 py-3 font-semibold text-gray-700">Stato</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((order, idx) => (
                  <tr
                    key={idx}
                    className="border-t border-gray-200 hover:bg-gray-50 text-black"
                  >
                    <td className="px-4 py-3">
                      {order.domain_name || "Dominio sconosciuto"}
                    </td>
                    <td className="px-4 py-3">
                      {order.method || "N/D"}
                    </td>
                    <td className="px-4 py-3">
                      {Number(order.amount).toFixed(2)}
                    </td>
                    <td className="px-4 py-3">
                      {new Date(order.order_date).toLocaleDateString()}
                    </td>
                    <td className="px-4 py-3">
                      <span
                        className={`px-2 py-1 rounded-full text-sm font-medium ${
                          order.status === "succeeded"
                            ? "bg-green-100 text-green-700"
                            : "bg-yellow-100 text-yellow-700"
                        }`}
                      >
                        {order.status}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};

export default UserPayments;
